<suite-rfb-collapse [collapsed]="filtroColapsado" (collapsedChange)="colapsar($event)" [title]="titulo">
  <suite-rfb-alert-messages-with-datetime [onlyFor]="this.scopeId"></suite-rfb-alert-messages-with-datetime>
  <div class="container-fluid" [class.janela-tamanho-fixo]="!this.atendimento">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <section class="section-custom">
        <h2 class="section-title">Documento</h2>
        <div class="row alinhar-itens-embaixo">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Número do Pagamento</label>
              <input class="form-control altura-fixa"
                    type="text"
                    autocomplete="off"
                    maxlength="17"
                    [formControlName]="numeroPagamentoName"
                    suiteRfbNumbersOnly
                    placeholder="Somente números">
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Número do Documento</label>
              <input class="form-control altura-fixa"
                    type="text"
                    autocomplete="off"
                    maxlength="17"
                    [formControlName]="numeroDocumentoName"
                    suiteRfbNumbersOnly
                    placeholder="Somente números">
            </div>
          </div>

          <!----- Removido pela demanda VIA-3571522 - COGEA 12428/2022 ----->
          <!--
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Número de Referência</label>
              <input
                class="form-control"
                type="text"
                autocomplete="off"
                [formControlName]="numeroReferenciaName"
                suiteRfbNumbersOnly>
            </div>
          </div>
          -->

          <!----- Adicionado pela demanda VIA-3571522 - COGEA 12428/2022 ----->
          <div class="col-md-4">
            <div class="form-group">
              <via-lazy-select label="Tipo do Documento"
                               [items$]="this.tiposDocumentoArrecadacao$"
                               [customFormControl]="this.formGroup.get(this.tipoDocumentoName)"
                               [lazyLabelFunction]="this.tipoDocumentoLabelFunction"
                               placeholder="Selecione">
              </via-lazy-select>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <suite-rfb-select label="Condição do Documento"
                                required="true"
                                [clearable]="false"
                                [labels]="this.condicoesDocumentoArrecadacao | condicoesDocArrecadacaoPipe"
                                [values]="this.condicoesDocumentoArrecadacao"
                                [formControlName]="this.condicaoDocumentoName">
              </suite-rfb-select>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-12">            
            <div class="form-group">

              @if (isCondicaoDocumentoEmitido()) {
              <label class="control-label checkbox-inline"
                     [class.cursor-bloqueado]="!this.formGroup.get(this.debitosNaoEfetivadosDaraOnlineName).enabled">
                <input class="checkbox" type="checkbox" [formControlName]="this.debitosNaoEfetivadosDaraOnlineName">
                <span>Documentos com débitos não efetivados pelo DARA Online</span>
              </label>
              }

              @if (this.isCondicaoDocumentoPago()) {
              <via-lazy-select label="Natureza do Documento"
                               [items$]="this.naturezasDocumentoArrecadacao$"
                               [customFormControl]="this.formGroup.get(this.naturezaDocumentoName)"
                               [lazyLabelFunction]="this.descricaoLabelFunction"
                               placeholder="Selecione">
              </via-lazy-select>
              }
            </div>
          </div>
        </div>
      </section>

      <section class="section-custom">
        <h2 class="section-title">Contribuinte</h2>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">CPF (sem DV)</label>
              <input class="form-control altura-fixa"
                    type="text"
                    autocomplete="off"
                    [formControlName]="cpfSemDvName"
                    suiteRfbInputMask="999.999.999"
                    placeholder="999.999.999">
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">CNPJ (sem DV)</label>
              <input class="form-control altura-fixa"
                    type="text"
                    autocomplete="off"
                    [formControlName]="cnpjSemDvName"
                    suiteRfbInputMask="99.999.999/9999"
                    placeholder="99.999.999/9999">
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label class="control-label checkbox-inline checkbox-ni-invalido" [class.cursor-bloqueado]="!this.formGroup.get(this.niInvalidoName).enabled">
                <input class="checkbox" type="checkbox" [formControlName]="niInvalidoName">
                <span>NI Inválido</span>
              </label>
            </div>
          </div>
        </div>
      </section>
      
      <section class="section-custom">
        <h2 class="section-title">Informações Bancárias e de Receita</h2>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="col-data-arrecadacao">
                  <div class="form-inline campo-data-arrecadacao">
                    <div class="form-group form-group-data-arrecadacao">
                      <label class="control-label">{{ this.labelData }} Inicial</label>
                      <suite-rfb-date-picker adaptivePosition="true"
                                            [formControlName]="dataArrecadacaoInicioName">
                      </suite-rfb-date-picker>
                    </div>
    
                    <label class="control-label data-arrecadacao-label-separador">a</label>
    
                    <div class="form-group form-group-data-arrecadacao">
                      <label class="control-label">{{ this.labelData }} Final</label>
                      <suite-rfb-date-picker adaptivePosition="true"
                                            [formControlName]="dataArrecadacaoFimName">
                      </suite-rfb-date-picker>
                    </div>

                    <div class="form-group form-group-checkbox-periodo-fixo">
                      <label class="control-label">Filtrar período por:</label>
                      <div>
                        @for (periodo of [1, 5, 12]; track $index) {
                        <div class="radio-inline checkbox-periodo-fixo"
                             [class.cursor-bloqueado]="!this.formGroup.get(this.periodoFixoName).enabled"
                             (click)="this.selecionarPeriodo(periodo)">
                          <input type="radio" class="ignorar-clique" [formControlName]="this.periodoFixoName" [value]="periodo">
                          <span>
                            @if (periodo === 1) {
                            Último ano
                            }
                            @else {
                            Últimos {{ periodo }} anos
                            }
                          </span>
                        </div>
                        }
                      </div>
                    </div>

                  </div>
                  <div *ngIf="this.formGroup.get(this.dataArrecadacaoInicioName).getError('faixaDataInvalida')" class="error-message">
                    A data inicial deve ser anterior ou igual à data final.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <label class="control-label">Receita</label>
              </div>
              <div class="col-md-6">
                <label class="control-label faixa-valor-label">Faixa de Valor</label>
              </div>
            </div>

            <!-- Alterado pela demanda VIA-3571522 - COGEA 12428/2022 -->
            <div class="col-md-6 col-receita">
              <div class="form-group">                
                <via-lazy-select [items$]="this.receitas$"
                                 [customFormControl]="this.formGroup.get(this.receitaName)"
                                 [lazyLabelFunction]="this.receitaLabelFunction"
                                 [virtualScroll]="true"
                                 placeholder="Selecione">
                </via-lazy-select>
              </div>
            </div>
            
            <div class="col-md-6 col-faixa-valor">
              <div class="form-inline">
                <div class="form-group form-group-faixa-valor">
                  <input class="form-control numerico altura-fixa"
                        type="text"
                        [formControlName]="faixaInicioName"                        
                        currencyMask
                        maxlength="15"
                        [options]="currencyMaskOptions"
                        placeholder="Valor mínimo">
                </div>

                <label class="control-label faixa-valor-label-separador">a</label>

                <div class="form-group form-group-faixa-valor">
                  <input class="form-control numerico altura-fixa"
                        type="text"
                        [formControlName]="faixaFimName"                        
                        currencyMask
                        maxlength="15"
                        [options]="currencyMaskOptions"
                        placeholder="Valor máximo">
                </div>
              </div>
              <div *ngIf="this.formGroup.get(this.faixaInicioName).getError('faixaInvalida')" class="error-message">
                O valor inicial deve ser menor ou igual ao valor final.
              </div>
            </div>
          </div>
        </div>     
        <div class="row">
          
          <div class="col-md-4">
            <div class="form-group">
              <via-lazy-select label="Banco"
                               [items$]="this.bancos$"
                               [customFormControl]="this.formGroup.get(this.bancoName)"
                               [lazyLabelFunction]="this.bancoLabelFunction"
                               [virtualScroll]="true"
                               placeholder="Selecione">
              </via-lazy-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <via-lazy-select label="Agência"
                               [items$]="this.agencias$"
                               [customFormControl]="this.formGroup.get(this.agenciaName)"
                               [lazyLabelFunction]="this.agenciaLabelFunction"
                               [virtualScroll]="true"
                               placeholder="Selecione">
              </via-lazy-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              @if (this.isCondicaoDocumentoPago()) {
              <via-lazy-select label="Modalidade de Arrecadação"
                               [items$]="this.modalidadesArrecadacao$"
                               [customFormControl]="this.formGroup.get(this.modalidadeArrecadacaoName)"
                               [lazyLabelFunction]="this.descricaoLabelFunction"
                               placeholder="Selecione">
              </via-lazy-select>
              }
            </div>
          </div>
        </div>   
      </section>

      <section class="section-custom">
        <h2 class="section-title">Nível de Pesquisa</h2>
        <div class="row">
          <div class="col-md-12">          
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="radio-inline" [class.cursor-bloqueado]="!this.formGroup.get(this.tipoPesquisaName).enabled">
                    <input type="radio" [formControlName]="tipoPesquisaName" [value]="TipoNivelPesquisa.DELEGACIA">
                    <span>Delegacia</span>
                  </label>
                </div>
                <div class="form-group">
                  <via-lazy-select [items$]="this.delegacias$"
                                   [customFormControl]="this.formGroup.get(this.delegaciaName)"
                                   [lazyLabelFunction]="this.delegaciaLabelFunction"
                                   placeholder="Selecione"
                                   dropdownPosition="top">
                  </via-lazy-select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="radio-inline" [class.cursor-bloqueado]="!this.formGroup.get(this.tipoPesquisaName).enabled">
                    <input type="radio" [formControlName]="tipoPesquisaName" [value]="TipoNivelPesquisa.REGIAO">
                    <span>Regional</span>
                  </label>
                </div>
                <div class="form-group">
                  <via-lazy-select [items$]="this.regioes$"
                                   [customFormControl]="this.formGroup.get(this.regiaoName)"
                                   [lazyLabelFunction]="this.regiaoLabelFunction"
                                   placeholder="Selecione"
                                   dropdownPosition="top">
                  </via-lazy-select>
                </div>
              </div>
            <div class="col-md-4">
                <div class="form-group">
                  <label class="radio-inline" [class.cursor-bloqueado]="!this.formGroup.get(this.tipoPesquisaName).enabled">
                    <input type="radio" [formControlName]="tipoPesquisaName" [value]="TipoNivelPesquisa.BRASIL">
                    <span>Brasil</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ng-template #templateModalErro>
        <div class="modal-header">
          <h4 class="modal-title pull-left">Atenção</h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="fecharModal()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="width: 600px;">
          <span *ngIf="nivelPesquisa?.tipo === TipoNivelPesquisa.DELEGACIA">
            Para o nível de Pesquisa por Delegacia, é obrigatório o preenchimento do código da Delegacia.
          </span>
          <span *ngIf="nivelPesquisa?.tipo === TipoNivelPesquisa.REGIAO">
            Para o nível de Pesquisa Regional, é obrigatório o preenchimento do código da Região Fiscal.
          </span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" (click)="fecharModal()">Fechar</button>
        </div>
      </ng-template>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <button class="btn btn-default" type="button" [disabled]="!this.formGroup.enabled" (click)="limparFormulario()">Limpar</button>
            <button class="btn btn-primary" type="submit" [disabled]="!this.formGroup.enabled || this.formGroup.invalid">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</suite-rfb-collapse>

<via-consulta-pagamentos *ngIf="exibeResultado"
                         [parametrosPesquisa]="parametros"
                         [atendimento]="true">
</via-consulta-pagamentos>